'use client';

import type { ReactNode } from 'react';

import '@/pagebuilder/register';

// Type definition of the RegisterClientPageBuilder component properties.

type Props = {
  children: ReactNode;
};

/**
 * RegisterClientPageBuilder component.
 *
 * Rendering this component will ensure the pagebuilder factories are registered on the client through the import of the `register` module.
 *
 * IMPORTANT:
 * - Should be used in the root layout to avoid unnecessary re-renders.
 */

const RegisterClientPageBuilder = ({ children }: Props) => {
  return children;
};

export default RegisterClientPageBuilder;
